import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconUsb: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="usb, connection, connect, save, data"><path d="M10 5.75V7.25M14 5.75V7.25M3.75 10.25H20.25V21.25H3.75V10.25ZM5.75 2.75H18.25V10.25H5.75V2.75Z" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/></CentralIconBase>;
};

export default IconUsb;
